export const gridSelectorStyles = {
  form: {
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'row',
  },
}
